export interface CalendarSource {
  type: CalendarSourceType;
  source:
    | 'airbnb-official'
    | 'airbnb'
    | 'api'
    | 'homeaway'
    | 'booking'
    | 'agoda'
    | 'override'
    | 'manual'
    | 'multiple'
    | 'none'
    | CalendarAvailabilityOverrideReason;
  date: string;
}

export enum CalendarAvailabilityOverrideReason {
  TurnoverDays = 'turnover_days',
  AvailabilityWindow = 'availability_window',
  BookingLeadTime = 'booking_lead_time',
  RollingAvailability = 'rolling_availability',
  RestrictedCheckin = 'restricted_checkin',
  RestrictedCheckout = 'restricted_checkout',
}

export enum CalendarSourceType {
  Price = 'price',
  Availability = 'availability',
  MinStay = 'min_stay',
  MaxStay = 'max_stay',
  CICOAvailability = 'cico',
}
